import { Box, Stack, SxProps, Typography } from '@mui/material';

import InfoIcon from '../../assets/icons/InfoIconBorderFill';
import colors from '../../constants/colors';

interface AutoPayOTSPBannerProps {
  paymentAmount: string;
  scheduledDate: string;
  sx?: SxProps;
}

const AutoPayOTSPBanner = ({
  paymentAmount,
  scheduledDate,
  sx = {},
}: AutoPayOTSPBannerProps) => {
  return (
    <Stack
      alignItems="center"
      direction="row"
      sx={{
        px: 3,
        py: 1,
        backgroundColor: colors.csaaBorder,
        borderRadius: 1,
        gap: 2,
        ...sx,
      }}
    >
      <InfoIcon />
      <Typography component="div" sx={{ fontSize: 14 }}>
        There is already a one-time payment of{' '}
        <Box component="span" sx={{ fontWeight: 'bold' }}>
          ${paymentAmount}
        </Box>{' '}
        that will process on{' '}
        <Box component="span" sx={{ fontWeight: 'bold' }}>
          {scheduledDate}
        </Box>
        . If your scheduled payment is processed before your AutoPay date, your
        automatic payment may be reduced by the amount of the scheduled payment.
      </Typography>
    </Stack>
  );
};

export default AutoPayOTSPBanner;
